import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const STORAGE_KEY = 'unbeatable_guided_mode';

function readStoredGuidedMode(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function persistGuidedMode(value: boolean) {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    /* ignore */
  }
}

export type GuidedModeState = {
  guidedMode: boolean;
};

const initialState: GuidedModeState = {
  guidedMode: readStoredGuidedMode(),
};

const guidedModeSlice = createSlice({
  name: 'guidedMode',
  initialState,
  reducers: {
    setGuidedMode: (state, action: PayloadAction<boolean>) => {
      state.guidedMode = action.payload;
      persistGuidedMode(action.payload);
    },
    toggleGuidedMode: (state) => {
      state.guidedMode = !state.guidedMode;
      persistGuidedMode(state.guidedMode);
    },
  },
});

export const { setGuidedMode, toggleGuidedMode } = guidedModeSlice.actions;
export default guidedModeSlice.reducer;
